import React from 'react';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import _adviserPortalHome from './_adviserPortalHome';
import { withTranslation } from 'react-i18next';
import '../css/AdviserPortalCharts.css';


function FumGraph(props) {
  const { t } = props;
  // Create chart instance
  let chart = am4core.create("fumChart", am4charts.PieChart);
  chart.logo.setVisibility(false)

  const total_Members = _adviserPortalHome._totalMembersInDetail(_adviserPortalHome._adviserDahsboardBodyInDetail(props))
  const colorPalette  = ["#51820F", "#304E09", "#81B037", "#003300"]

  // Add data
  chart.data = [];
  // chart.data = [{
  //   "product": "SuperLife KiwiSaver Members",
  //   "members": total_Members.kiwiSaver,
  //   "color": "#51820F"
  // }, {
  //   "product": "SuperLife Invest Members",
  //   "members": total_Members.invest,
  //   "color": "#304E09",
  //   // #003300
  // }, {
  //   "product": "SuperLife UK Members",
  //   "members": total_Members.ukPension,
  //   "color": "#81B037"
  // }];

  total_Members.productMembers.map((members, index) => {
    const data = {
      product: members.name,
      members: members.members,
      code: members.code,
      color: colorPalette[index]
    }
    chart.data.push(data)
  })
  const pieSeries = chart.series.push(new am4charts.PieSeries())
  pieSeries.dataFields.value = "members";
  pieSeries.dataFields.category = "code";
  pieSeries.slices.template.propertyFields.fill = "color";

  // pieSeries.alignLabels = false;
  // pieSeries.labels.template.bent = true;
  // Let's cut a hole in our Pie chart the size of 40% the radius
  chart.innerRadius = am4core.percent(70);
  chart.radius = am4core.percent(100)
  pieSeries.ticks.template.disabled = true;
  pieSeries.alignLabels = false;
  pieSeries.labels.template.disabled = true;
  // pieSeries.labels.template.text = "{value.percent.formatNumber('#.0')}%";
  // Put a thick white border around each Slice
  pieSeries.slices.template.stroke = am4core.color("#FFFFFF");
  pieSeries.slices.template.strokeWidth = 2;
  pieSeries.slices.template.strokeOpacity = 1;

  //Lables inside the Donut chart
  var label = pieSeries.createChild(am4core.Label);
  var label2 = pieSeries.createChild(am4core.Label)
  label.text = "{values.value.sum}";
  label2.text = t('Graphs:fumGraphLabel')
  label.horizontalCenter = "middle";
  label.verticalCenter = "bottom";
  label2.horizontalCenter = "middle";
  label2.verticalCenter = "top";
  label.fontSize = "24pt";
  label2.fontSize = "9pt";
  label.fill = am4core.color("#3d4d5c");
  label2.fill = am4core.color("#3d4d5c");

  // Add a legend
  chart.legend = new am4charts.Legend();
  chart.legend.valueLabels.template.disabled = true; //Do not display the values for legends. 
  chart.legend.markers.template.height = 10;
  chart.legend.markers.template.width = 10;
  chart.legend.labels.template.fill = am4core.color("#3d4d5c");
  chart.legend.margin(30, 0, 0, 0)

  // chart.legend.height = 150;
  // chart.legend.width = 300;

  // Add and configure Series
  // let pieSeries = chart.series.push(new am4charts.PieSeries());
  // chart.radius = "100%";
  // pieSeries.dataFields.value = "members";
  // pieSeries.dataFields.category = "product";
  // pieSeries.slices.template.propertyFields.fill = "color";
  // pieSeries.labels.template.text = "{value.percent.formatNumber('#.0')}%";

  // chart.legend = new am4charts.Legend();
  // chart.legend.markers.template.height = 10;
  // chart.legend.markers.template.width = 10;

  return (
    <div style={{ textAlign: "center" }}>
      <div className="fumChartTitle">{t('Graphs:fumGraphTitle')}</div>
      <div id="fumChart"></div>
    </div>
  )
}
export default withTranslation()(FumGraph);
